import { Absence } from './Absence';

export class Account {
  // 'approved','pending','rejected'
  evaluationStatus?: 'approved' | 'pending' | 'rejected'
  isEvaluable?: boolean
  absence?: Absence
  url?: string

  // keep the naming same to backend
  is_newsletter_subscribed?: boolean
  birthday?: string
  phone?: number
  bank_iban?: string
  bank_swift?: string
  addressline_1?: string
  city?: string
  zip?: string
  country?: string
  email?: string
  associations?: any[]
  professions?: any[]
  finnish_artists_assoc?: boolean

  // translations
  about?: any
  education?: any
  memberships?: any
  solo_exhibitions?: any
  group_exhibitions?: any
  grants?: any
  residences?: any
  collections?: any

  constructor(data: Partial<Account> = {}) {
    Object.assign(this, data)
  }

}
